import React,{useState,useEffect} from 'react'
import '../Css/Registry.css';
import '../App.css';
import axios from 'axios';
import {toast} from "react-toastify";
import { useNavigate } from 'react-router-dom';
import calendar from '../icon/icons8-calendar-96.png';
import booking from '../icon/icons8-booking-96.png';



function Booking() {

  //navigation
  const navigate = useNavigate();
  const [phone,setPhone] = useState('');
  const [name,setName] = useState('');

  //store memberState
  const [memberState,setMemberState] = useState(false);
  
  //store the event
  const [data,setData] = useState([]);

  //store the booking event
  const [selectedEvents, setSelectedEvents] = useState([])
    



  //connect to api to get result
    function connectPhp(){
        let data =[];
        axios.get("https://www.pta-hk.com/getEventList.php").then
        (response=>{
            data = response.data;
            setData(data);
            console.log(data);
        }).catch((e)=>console.log(e));
    }

    function bookingEvent(){
        let dataSend = [];
        const url="https://pta-hk.com/bookingEvent.php";
        let fData =new FormData();
        fData.append('name',name);
        fData.append('phone',phone);
        fData.append('memberState',memberState);
        
        //pass all seleced event to array
        selectedEvents.forEach(event => {
            fData.append('selectedEvents[]', event);
        });
                
        axios.post(url,fData).then
        (response=>{
                let dataResponse = response.data;
                console.log(dataResponse);
                if(dataResponse ==="bookingSuccess"){
                    toast.success("預約成功,到時見..",{
                        position:"top-center",
                    });      
                    //navigate to Reg Comfirm component
                     navigate('/MyBooking', { state: { phone: phone } });

                }
        }).catch((e)=>console.log(e));
        
    }

    useEffect(()=>{
        connectPhp();
    },[]);


  function handlePhoneChange(e){
    const value =e.target.value;
    setPhone(value);
  }
  
  function handleNameChange(e){
    const value = e.target.value;
    setName(value);
  }

  // Handle checkbox selection
  const handleEventSelection = (eventId) => {
    setSelectedEvents(prevSelected => {
      if (prevSelected.includes(eventId)) {
        // If already selected, remove it
        return prevSelected.filter(id => id !== eventId);
      } else {
        // If not selected, add it
        return [...prevSelected, eventId];
      }
    });
  };
    
      
  const handleSubmit = (e)=>{
    e.preventDefault();
    const cleanedPhoneNum = phone.replace(/[^\d]/g, '').slice(0, 8);
      //check the start of number
      //^ start of number
      //[23569] -First digit must be 
      //d{7} -followed by 7 digit
      const valid = /^[23569]\d{7}$/.test(cleanedPhoneNum);
      console.log("Valid PhoneNum", valid);
    
    //valid phone number checked
    if (valid) {
        console.log('valid phone submitted !');
        bookingEvent();
        console.log("PhoneNumber : ",phone);
        console.log("Name: ",name);
        console.log("MemberState:",memberState);
        console.log("Booked Event:",selectedEvents);

    }else{
        toast.error("請輸入有效電話號碼..",{
            position:"top-center",
        });      
        console.log('Please enter a valid telephone number ');
    }    

    
  }  


  return (
    <div className="container">
        <div className="container-content">
            <div className="registry-content">
                <div className="title">預約比賽&nbsp;&nbsp;
                    <img src={booking}
                        alt="Poker Tournament Association"
                        className="icon"
                    />
                </div>
                <form onSubmit = {handleSubmit} className="booking-form">
                    <div className="booking-form-group">
                         <div className="form-notice">
                            *必須墳寫
                        </div>
                    </div>
                    {/********  Name ******/}  
                     <div className="booking-form-group">
                        <label span id="formInputLabel">姓名*:&nbsp;&nbsp;</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="text"
                            id="name"
                            value={name}
                            
                            onChange={handleNameChange}
                              style={{
                                  padding:'8px',
                                  border:`1px solid #ccc`,
                                  borderRadius:'4px',
                                  width:'100px' ,
                                  backgroundColor:"#e0e0e0"
                        }}
                    />
                    </div>

                    {/********** Phone Input *****/}
                    <div className="booking-form-group">
                        <label span id="formInputLabel">聯絡電話*:</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="text"
                            maxLength={8}
                            id="phone"
                            value={phone}
                            onChange={handlePhoneChange}
                            style={{
                                padding:'8px',
                                border:`1px solid #ccc`,
                                borderRadius:'4px',
                                width:'100px',
                                backgroundColor:"#e0e0e0" 
                            }}
                        />
                    </div>
                    
                    {/********** Is member  Input *****/}
                    <div className="booking-form-group">
                        <label span id="formInputLabel">是否會員&nbsp;?&nbsp;</label>&nbsp;&nbsp;
                        <input className="form-input"
                            type="checkbox"
                            id="memberState"
                            checked={memberState}
                            onChange={()=>setMemberState(!memberState)}
                             style={{
                                padding:'8px',
                                border:`1px solid #ccc`,
                                borderRadius:'4px',
                                backgroundColor:"#e0e0e0" 
                            }}
                        />
                    </div>

                    {/**** Show all event list */}
                    <div className="booking-form-group">
                        <div className="eventTable">
                            <div className="title">比賽日程 &nbsp;&nbsp;
                                <img src={ calendar }
                                    alt="Poker Tournament Association"
                                    className="icon"
                                />
                            </div>
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th>選擇</th>
                                        <th>編號</th>
                                        <th>日期</th>
                                        <th>時間</th>
                                        <th>名稱</th>
                                        <th>入場費</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.map((item)=>(
                                    <tr key={item.id}>
                                        <td>
                                            <input className="form-input"
                                                type="checkbox"
                                                id={`event-${item.EventId}`}
                                                checked={selectedEvents.includes(item.EventId)}
                                                onChange={() => handleEventSelection(item.EventId)}
                                                style={{
                                                    padding:'8px',
                                                    border:`1px solid #ccc`,
                                                    borderRadius:'4px',
                                                    backgroundColor:"#e0e0e0" 
                                                }}

                                            />
                                        </td>
                                        <td>{item.EventId}</td>
                                        <td>{item.StartDate}</td>
                                        <td>{item.StartTime}</td>
                                        <td>{item.EventGame}</td>
                                        <td>{item.Fee}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <div id="submitButton">
                                <button type="submit"
                                    onClick={() => console.log("Button clicked!")}
                                    style={{
                                    backgroundColor:'#F01010',
                                    color:'#ffffff',
                                    marginTop:'20px',
                                    padding:'8px 15px',
                                    border:'none',
                                    borderRadius:'4px',
                                    cursor:'pointer',
                                    width:'200px'
                                    }}
                                >
                                    確認
                                </button>  
                            </div>     
                        </div>        
                    </div>
                </form>    
            </div>
            
        </div>
    </div>                    
  )
}

export default Booking
